import React from 'react';
import Image from 'next/image';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white shadow-md border-t border-gray-100 p-6 mt-auto">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between">
          <div className="flex items-center mb-6 sm:mb-0">
            {/* Logo SIR avec image */}
            <div className="relative h-12 w-16 mr-3">
              <Image 
                src="/logo-sir.png" 
                alt="Logo SIR Plomberie" 
                fill 
                style={{ objectFit: 'contain' }}
              />
            </div>
            
            <div>
              <h3 className="text-lg font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">Plomberie</h3>
              <div className="flex text-xs text-gray-600 font-medium tracking-wider items-baseline">
                <span className="font-black text-primary text-xs">S</span>
                <span>anitaire</span>
                <span className="font-black ml-1 text-primary text-xs">I</span>
                <span>nstallation</span>
                <span className="font-black ml-1 text-primary text-xs">R</span>
                <span>éparation</span>
              </div>
            </div>
          </div>
          
          <div className="text-center sm:text-right">
            <p className="text-sm font-medium text-gray-600">Intervention Paris et région parisienne</p>
            <p className="text-sm font-bold text-primary">7j/7 & 24h/24</p>
            <p className="text-sm font-medium text-gray-600 mt-1">Steeve Zarka</p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-center sm:justify-start mt-6 space-y-3 sm:space-y-0 sm:space-x-6 border-t border-gray-100 pt-4">
          <a 
            href="tel:0658656990" 
            className="flex items-center justify-center sm:justify-start text-secondary hover:text-primary transition-colors py-2 px-4 rounded-md hover:bg-gray-50 group"
          >
            <div className="bg-primary/10 p-2 rounded-full mr-3 group-hover:bg-primary/20 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <span className="font-medium pr-10">06 58 65 69 90</span>
          </a>
          
          <a 
            href="mailto:sir.plomberie75@gmail.com" 
            className="flex items-center justify-center sm:justify-start text-secondary hover:text-primary transition-colors py-2 px-4 rounded-md hover:bg-gray-50 group"
          >
            <div className="bg-primary/10 p-2 rounded-full mr-3 group-hover:bg-primary/20 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <span className="font-medium pr-5">sir.plomberie75@gmail.com</span>
          </a>
        </div>
        
        {/* Liens légaux et copyright */}
        <div className="mt-4 pt-4 border-t border-gray-100 text-center space-y-2">
          <a 
            href="/mentions-legales" 
            className="text-xs text-gray-500 hover:text-primary transition-colors underline block"
          >
            Mentions légales et politique de confidentialité
          </a>
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} Plomberie SIR - Steeve Zarka. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 